export function Placeholder({ title, description }: { title: string; description?: string }) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <h1 className="text-2xl font-bold text-admin-900">{title}</h1>
      <p className="mt-2 max-w-md text-sm text-admin-700">
        {description ?? "Em breve. Essa area sera implementada na proxima iteracao."}
      </p>
    </div>
  );
}
